import { Component, Input } from '@angular/core';

@Component({
  selector: 'tad-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss'],
})
export class DialogContainerComponent {
  @Input() public dialogTitle = '';
  @Input() public isCloseIconVisible = true;
  @Input() public wrapTitle = false;
}
